module.exports = __webpack_public_path__ + "img/des_muyu_1.1afcac0b.jpg";